import { ExpandMore } from '@mui/icons-material';
import * as T from '../Typography';
import * as S from './style';

import { AccordionDetails, AccordionSummary } from '@mui/material';

const FAQItem = ({ question, answer }) => {
  return (
    <S.AccordionStyled>
      <AccordionSummary
        expandIcon={<ExpandMore />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <T.TextSmallBold>{question}</T.TextSmallBold>
      </AccordionSummary>
      <AccordionDetails>
        <T.TextSmallRegular dangerouslySetInnerHTML={{ __html: answer }} />
      </AccordionDetails>
    </S.AccordionStyled>
  );
};

export default FAQItem;
